module.exports = __webpack_public_path__ + "static/media/Logo.c66223ce.jpg";